//从字符串中捕获参数
export function getParaFromString(str, paraName) {
  var data = {}
  ;(('' + str).match(/([^=&#\?]+)=[^&#]+/g) || []).forEach((para, i) => {
    var d = para.split('='),
      val = decodeURIComponent(d[1])
    if (data[d[0]] !== undefined) {
      data[d[0]] += ',' + val
    } else {
      data[d[0]] = val
    }
  })
  return paraName ? data[paraName] || '' : data
}

//从URL中捕获参数
export function getUrlPara(paraName) {
  //window.location.search 第一个"?"之后
  //查询字符串search只能在取到“?”后面和“#”之前的内容，如果“#”之前没有“?”search取值为空。
  return getParaFromString(window.location.search.replace(/^\?/g, ''), paraName)
}

//从HASH中捕获参数
export function getHashPara(paraName) {
  //FireFox中location.hash会默认进行解码,所以只能通过location.href来获取hash
  var match = window.location.href.match(/#(.*)$/)
  return getParaFromString(match ? match[1] : '', paraName)
}

//综合读取
export function getPara(paraName) {
  return getUrlPara(paraName) || getHashPara(paraName)
}

export function addUrlPara(href, para, removeSamePara) {
  var url = (href + '').split('#'),
    sp
  //先移除同名参数
  if (removeSamePara) {
    url[0] = removeUrlPara(
      url[0],
      para.match(/([^=&#\?]+)=[^&#]+/g).map(str => str.replace(/=.+$/, ''))
    )
  }
  sp = url[0].indexOf('?') + 1 ? '&' : '?'
  return (url[0] + sp + para + (url.length > 1 ? '#' + url[1] : '')).replace(
    /\?\&/,
    '?'
  )
}

export function addHashPara(href, para, removeSamePara) {
  var url = (href + '').split('#'),
    sp
  // 不存在hash值则直接返回
  if (!url[1]) return href
  //先移除同名参数
  if (removeSamePara) {
    url[1] = removeUrlPara(
      url[1],
      para.match(/([^=&#\?]+)=[^&#]*/g).map(str => str.replace(/=.+$/, ''))
    )
  }
  sp = url[1].indexOf('?') + 1 ? '&' : '?'
  return (url[0] + '#' + url[1] + sp + para).replace(/\?\&/, '?')
}

/**
 * @name removeUrlPara
 * @param {string} url 要处理的url
 * @param {string|array<string>} [paraName] 要移除的参数或数组，比如 "id" 或 ["name","id"]，如果不传此参数，则全部移除
 * @return {string} 处理好的url字符串
 */
export function removeUrlPara(url, paraName) {
  var arr1 = url.split('#'),
    arr2 = arr1[0].split('?'),
    base = arr2[0],
    para = arr2.length > 1 ? arr2[1] : '',
    hash = arr1.length > 1 ? '#' + arr1[1] : '',
    paraReg =
      typeof paraName === 'string' && paraName
        ? [paraName]
        : paraName.join
        ? paraName
        : []
  if (!paraReg.length || !para) {
    return base.replace(/\?.+$/, '') + hash
  }
  paraReg.map(str => str.replace(/([\\\(\)\{\}\[\]\^\$\+\-\*\?\|])/g, '\\$1'))
  return (
    (
      base +
      '?' +
      para
        .replace(
          new RegExp('(?:^|&)(?:' + paraReg.join('|') + ')=[^&$]+', 'g'),
          ''
        )
        .replace(/^&/, '')
    ).replace(/\?$/, '') + hash
  )
}

export function getCurDomainUrl() {
  const protocol = window.location.protocol
  const domain = '//' + (document.domain || 'kids.youdao.com')
  return protocol + domain
}
